import PerformanceSDK, {
  type PerformanceConfig,
  type PerformanceSDK as PerformanceSDKType,
} from "@didi/sofi-performance-sdk";
import type { MetricName } from "@didi/sofi-performance-sdk/dist/metric-map";
import { trackEvent } from "./omega";

let performanceSDK: PerformanceSDKType | null = null;
let initialized = false;

const trackPerformanceMetric: PerformanceConfig["trackEvent"] = (key, value) => {
  if (key === "error_key") {
    trackEvent("tech_sofi_catch_error", {
      source: "performance.no_support",
      data: String(value),
    });
    return;
  }

  trackEvent("tech_performance_custom", {
    timingCategory: key,
    timingName: key,
    timingValue: value,
    timing_category: key,
    timing_name: key,
    timing_value: value,
    page_path: window.location.pathname,
  });
};

export const initPerformanceSdk = (): PerformanceSDKType => {
  if (!performanceSDK) {
    performanceSDK = new PerformanceSDK();
  }

  if (!initialized) {
    performanceSDK.init({
      trackEvent: trackPerformanceMetric,
      blankScreen: true,
    });
    initialized = true;
  }

  return performanceSDK;
};

export const reportPerformanceMetric = (metric: MetricName) => {
  initPerformanceSdk().report(metric);
};

export const reportPerformanceApi = (api: string, duration: number) => {
  initPerformanceSdk().reportApi(api, duration);
};

initPerformanceSdk();
